<template>
    <div
        class="sidebar"
        :data-color="backgroundColor"
        :data-active-color="activeColor"
    >
        <div class="logo">
            <a
                class="simple-text logo-mini"
                aria-label="sidebar mini logo"
                @click="gotToOldManageArea"
            >
                <div class="logo-img">
                    <img :src="logo" alt="" />
                </div>
            </a>
            <a class="simple-text logo-normal" @click="gotToOldManageArea">
                {{ title }}
            </a>
        </div>

        <div class="sidebar-wrapper" ref="sidebarScrollArea">
            <slot> </slot>
            <ul class="nav">
                <slot name="links">
                    <sidebar-item
                        v-for="(link, index) in sidebarLinks"
                        :key="link.name + index"
                        :link="link"
                    >
                        <sidebar-item
                            v-for="(subLink, index) in link.children"
                            :key="subLink.name + index"
                            :link="subLink"
                        >
                        </sidebar-item>
                    </sidebar-item>
                </slot>
            </ul>
        </div>
    </div>
</template>
<script>
import "perfect-scrollbar/css/perfect-scrollbar.css";
import PracticeServices from "src/services/practices/practiceServices.js";
import SidebarItem from "./SidebarItem.vue";
import { redirectToOldPracticeDashboard } from "@/util/OldDashboardLink.js";
import MessagingServices from "src/services/Messaging/MessagingServices.js";
import { CollapseTransition } from "vue2-transitions";
import Vue from 'vue'

export default {
    components: {
        SidebarItem,
        CollapseTransition,
    },
    data() {
        return {
            linkBackToSite: "../home/healthtrac/index.asp", // Homepage
             sidebarLinks: [
                 {
                    name: 'Practice Dashboard',
                    icon: 'nc-icon nc-world-2',
                    path: '/practicedashboard'
                },
                {
                    name: 'Practice',
                    icon: 'nc-icon nc-bank',
                    path: '/practice'
                },
                {
                    name: 'User Management',
                    icon: 'nc-icon nc-badge',
                    path: '/UserManagement'
                },
                {
                    name: 'Groups',
                    icon: 'nc-icon nc-layout-11',
                    path: '/Groups'
                },
                {
                    name: 'Client Summary Report',
                    icon: 'nc-icon nc-settings-gear-65',
                    path: '/ClientReport'
                },
                {
                    name: 'Practice Report',
                    icon: 'nc-icon nc-single-copy-04',
                    path: '/PracticeReport'
                },
                {
                    name: 'Build Badge',
                    icon: 'nc-icon nc-badge',
                    path: '/BuildBadge'
                },
                {
                    name: 'Reports',
                    icon: 'nc-icon nc-paper',
                    path: '/Reports'
                },
                {
                    name: 'Inbox',
                    icon: 'nc-icon nc-email-85',
                    path: '/Inbox',
                    notification: false
                },
                // {
                //     name: 'Resource Center',
                //     icon: 'nc-icon nc-single-copy-04',
                //     path: '/resourcecenter' 
                // },
            ],
            appointmentPlusLink: {
                name: 'Scheduling',
                icon: 'nc-icon nc-calendar-60',
                path: '/appointmentPlus',
            },
        };
    },
    props: {
        htTitle: {
            type: String,
            default: "HealthTrac",
            description: "Sidebar title",
        },
        tmdTitle: {
            type: String,
            default: "Track My Day",
            description: "TMD sidebar title",
        },
        backgroundColor: {
            type: String,
            default: "white",
            validator: (value) => {
                let acceptedValues = ["white", "brown", "black"];
                return acceptedValues.indexOf(value) !== -1;
            },
            description: "Sidebar background color (white|brown|black)",
        },
        activeColor: {
            type: String,
            default: "success",
            validator: (value) => {
                let acceptedValues = [
                    "primary",
                    "info",
                    "success",
                    "warning",
                    "danger",
                ];
                return acceptedValues.indexOf(value) !== -1;
            },
            description:
                "Sidebar active text color (primary|info|success|warning|danger)",
        },
        htLogo: {
            type: String,
            default: "htFavicon.png",
            description: "Sidebar Logo",
        },
        tmdLogo: {
            type: String,
            default: "TMDFavicon.png",
            description: "Sidebar logo if on TMD",
        },
        autoClose: {
            type: Boolean,
            default: true,
        },
    },
    provide() {
        return {
            autoClose: this.autoClose,
        };
    },
    computed: {
        title() {
            if (window.location.hostname.includes("trackmyday.org")) {
                return this.tmdTitle;
            } else {
                return this.htTitle;
            }
        },
        logo() {
            if (window.location.hostname.includes("trackmyday.org")) {
                return this.tmdLogo;
            } else {
                return this.htLogo;
            }
        },
    },
    watch: {
        "$store.state.notificationBus.inboxMessageRead"() {
            console.log("Inbox::notification recieved::message read");
            this.getMessages();
            return this.$store.state.notificationBus.inboxMessageRead;
        },
    },
    methods: {
        async initScrollBarAsync() {
            let isWindows = navigator.platform.startsWith("Win");
            if (!isWindows) {
                return;
            }
            const PerfectScroll = await import("perfect-scrollbar");
            // PerfectScroll.initialize(this.$refs.sidebarScrollArea) This appears to be deprecated: NEED TO FIX
        },
        async loadUserComponents() {
            var thisPractice =
                this.$store.getters["currentUser/getCurrentUsersPractice"];
            var thisUser =
                this.$store.getters["currentUser/getCurrentUsersLogin"];

            var components = await PracticeServices.LoadComponentsList(
                thisPractice,
                thisUser
            );
            var componentsList = components.result;
              if(componentsList){
            if (componentsList.includes("APPOINTMENT_PLUS")) {
                this.sidebarLinks.push(this.appointmentPlusLink)
            }
            if (componentsList.includes("OLD_MANAGE_AREA")) {
                this.linkBackToSite = "../method_sph_coach/1000.asp"; // Manage
            }
            if (window.location.hostname.includes("trackmyday.org")) {
                this.linkBackToSite = this.linkBackToSite.replace('..', '')
            }
        }
        },
        async getMessages() {
            var numUnreadMessages = 0;
             var practice = this.$store.getters["currentUser/getCurrentUsersPractice" ];
            var InboxMessage = {
            Login: this.$store.getters["currentUser/getCurrentUsersLogin"],
            PracticeCode:practice,
           }
         var data = await MessagingServices.getInbox(InboxMessage);
          if (data !== null && data !== undefined && data.result) {
                if (data.result.length != 0) 
                {
                    for (var message of data.result) {
                        if (message.acked != "Y") {
                            numUnreadMessages += 1;
                        }
                    }
                }
          }
            var role = this.$store.getters["currentUser/getCurrentUsersRole"];
            if (role == "MANAGEMENT" || role == "PRACTICE-MANAGEMENT") {
                 var InboxMessage = {
                 Login: this.$store.getters["currentUser/getCurrentUsersPractice"],
                 PracticeCode:practice,
           }
                var data = await MessagingServices.getInbox(InboxMessage);
                 if (data !== null && data !== undefined && data.result) {
                    if (data.result.length != 0) 
                    {
                        for (message of data.result) {
                            if (message.acked != "Y") {
                                numUnreadMessages += 1;
                            }
                        }
                    }
                 }
            }
            var inboxLinkIndex = this.sidebarLinks.findIndex((x) => x.name == 'Inbox')
            var inboxLink = this.sidebarLinks[inboxLinkIndex]
            inboxLink.notification = numUnreadMessages
            Vue.set(this.sidebarLinks, inboxLinkIndex, inboxLink)
        },
        gotToOldManageArea() {
            redirectToOldPracticeDashboard(this.linkBackToSite, null, {
                SPH_RETURN: "",
            });
        },
    },
    async created() {
 const role = this.$store.getters["currentUser/getCurrentUsersRole"];
  const allowedRoles = ['MANAGEMENT', 'PRACTICE-MANAGEMENT', 'SERVICE', 'PROVIDER', 'COACH'];

  if (allowedRoles.includes(role)) {
    this.sidebarLinks.push({
      name: 'Progress Tracker',
      icon: 'nc-icon nc-chart-bar-32',
      path: '/ProgressTracker'
    });
  };

        await this.loadUserComponents();
    },
    mounted() {
        this.initScrollBarAsync();
        this.getMessages();
    },
    beforeDestroy() {
        if (this.$sidebar.showSidebar) {
            this.$sidebar.showSidebar = false;
        }
    },
};
</script>
<style>
@media (min-width: 992px) {
    .navbar-search-form-mobile,
    .nav-mobile-menu {
        display: none;
    }
}
.externalLink {
    display: block;
    margin-left: 10%;
    margin-right: auto;
    width: 50%;
    margin-top: inherit;
    font-weight: inherit;
    font-size: 12px;
}

.logo :hover {
    cursor: pointer;
}
</style>
